import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsmoduleService } from '../../manage/cmsmodule/service/cmsmodule.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { BannerService } from '../../services/banner.service';
//import { OwlOptions } from 'ngx-owl-carousel-o';
import { CustomValidators } from 'ng2-validation';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
//import { ReferAFriendService } from '../service/referAFriendService.service';
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class AboutUsComponent implements OnInit {
  public loading: boolean;
  public cmsContent;
  public cmsContentData;
  public totalBanners = 0;
  public bannerImageList: any[] = [];
  public totalRecords: 0;
  public errorMessage: string;
  public bannerList: any[];

  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  public show: boolean = true;

  public slides = [
    {
    "banner_image_src": "assets/img/slide/4ac21-16764340568332-1920.jpg"
    },
    {
    "banner_image_src": "http://localhost:3006/uploads/bannerImage/7e8aa0ef-6117-42c4-897a-955159cb6957.jpeg"
    },
    {
    "banner_image_src": "http://localhost:3006/uploads/bannerImage/2445f86d-9ec7-498c-9230-352f72d73e99.jpeg"
    },
    {
    "banner_image_src": "http://localhost:3006/uploads/bannerImage/4c708e5c-3ed6-4641-bc00-6ecc0a1d96d4.jpeg"
    }
    ]
  public slides1: any[] = [];



  public type: string = 'component';

  public disabled: boolean = false;

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 4,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 3,
      slideShadows: true
    },
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }    
  };

  // private scrollbar: SwiperScrollbarInterface = {
  //   el: '.swiper-scrollbar',
  //   hide: false,
  //   draggable: true
  // };

  // private pagination: SwiperPaginationInterface = {
  //   el: '.swiper-pagination',
  //   clickable: true,
  //   hideOnClick: false
  // };

  @ViewChild(SwiperComponent) componentRef?: SwiperComponent;
  @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;

  constructor(private cmsmoduleService: CmsmoduleService,
    private bannerService: BannerService,
    private formBuilder: FormBuilder, private messageService: MessageService, private router: Router,
    //private referAFriendService: ReferAFriendService
  ) {

  }
  ngOnInit(): void {
    this.getCmsContent();
    this.getBanner();
  }

  getCmsContent() {
    var query = "?filterByDisable=false&filterByStatus=true&filterBySlug=about_league";
    this.cmsmoduleService.getContentDetails(query).subscribe(
      data => {
        this.loading = false;
        this.cmsContent = data.data.items[0];
        if (this.cmsContent != undefined) {
          this.cmsContentData = this.cmsContent['cmsDescription'];
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }


  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=about_league";
    this.bannerService.getbannerList(query).subscribe(
      data => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach(element => {
          this.bannerImageList = element.banner_image;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }




  public toggleDisabled(): void {
    this.disabled = !this.disabled;
  }
  public onIndexChange(index: number): void {
    // console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    // console.log('Swiper event: ', event);
  }






  

  public toggleKeyboardControl(): void {
    this.config.keyboard = !this.config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.config.mousewheel = !this.config.mousewheel;
  }

}
